import React from 'react';
import { io } from 'socket.io-client';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

const DecisionCheck = ({ check, setCheck, title, body, socketName, id }) => {
  const ENDPOINT = process.env.REACT_APP_SOCKET_URL;

  const handleClose = () => {
    setCheck({ show: false, proceed: false });
  };

  const handleDelete = () => {
    const socket = io(ENDPOINT, { transports: ['websocket'] });
    const payload = {
      userId: localStorage.getItem('id'),
      id,
    };
    socket.emit(socketName, payload);
    handleClose();
  };

  return (
    <Dialog open={check.show} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => setCheck({ ...check, show: false })}>
          No
        </Button>
        <Button variant="contained" color="error" onClick={handleDelete}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DecisionCheck;
